import { PostApiSpoGendersBody, SpoGendersResponse } from '@spo/types';
import { apiBff } from '.';

export const getGenders = async (
  postApiSpoGendersBody: PostApiSpoGendersBody,
): Promise<SpoGendersResponse> => {
  return apiBff.callBFF('POST', 'spo/genders', postApiSpoGendersBody);
};
